"use client";

import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import {
  ShopBreadcrumbsProvider,
  useShopBreadcrumbs,
} from "@/integrations/wordpress/WordPressEcommerceShopBreadcrumbs";

function ShopBreadcrumbsConsumer() {
  const { links, loading, error } = useShopBreadcrumbs();

  if (loading) {
    return (
      <div className="flex items-center gap-2">
        <div className="h-3 w-16 animate-pulse rounded-md bg-muted" />
        <div className="h-3 w-3 animate-pulse rounded-md bg-muted" />
        <div className="h-3 w-24 animate-pulse rounded-md bg-muted" />
      </div>
    );
  }

  if (error || links.length === 0) return null;

  const lastIndex = links.length - 1;
  const currentTitle = links[lastIndex]?.title ?? "";

  return (
    <div className="flex flex-col items-center gap-6 md:gap-8">
      <Breadcrumb>
        <BreadcrumbList className="justify-center text-xs uppercase tracking-[0.2em] text-green-900/70">
          {links.map((link, i) => (
            <BreadcrumbItem data-index={i} key={`${link.href}-${i}`}>
              {i === lastIndex ? (
                <BreadcrumbPage className="font-default text-green-900/50">
                  {link.title}
                </BreadcrumbPage>
              ) : (
                <>
                  <BreadcrumbLink
                    href={link.href}
                    className="font-default transition-colors hover:text-green-900"
                  >
                    {link.title}
                  </BreadcrumbLink>
                  <BreadcrumbSeparator className="text-green-900/40" />
                </>
              )}
            </BreadcrumbItem>
          ))}
        </BreadcrumbList>
      </Breadcrumb>

      <div className="flex flex-col items-center gap-5">
        <div className="h-px w-12 bg-green-600/30" aria-hidden="true" />
        <h1 className="font-default text-4xl font-light tracking-wide text-green-950 sm:text-5xl md:text-6xl lg:text-7xl">
          {currentTitle}
        </h1>
        <div className="h-px w-12 bg-green-600/30" aria-hidden="true" />
      </div>
    </div>
  );
}

export default function Archive() {
  return (
    <section data-section-id="2362"
      id="archive-title"
      className="bg-stone-50 text-green-950"
    >
      <div className="mx-auto max-w-5xl px-6 py-16 sm:py-20 md:py-24 lg:py-28">
        <ShopBreadcrumbsProvider>
          <ShopBreadcrumbsConsumer />
        </ShopBreadcrumbsProvider>
      </div>
    </section>
  );
}